// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomGetQuoteApiParameter, CustomQuoteModel, getQuote } from "@ces/App/Services/QuoteService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<CustomGetQuoteApiParameter, CustomQuoteModel>;

export const DispatchBeginLoadQuote: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomQuotes/BeginLoadQuote",
        quoteNumber: props.parameter.quoteNumber,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getQuote(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Data/CustomQuotes/FailedToLoadQuote",
                quoteNumber: props.parameter.quoteNumber,
                status: 404,
            } as any);
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadQuote: HandlerType = props => {
    props.dispatch({
        type: "Data/CustomQuotes/CompleteLoadQuote",
        quote: props.apiResult,
    } as any);
};

export const chain = [DispatchBeginLoadQuote, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadQuote];

const loadCustomQuote = createHandlerChainRunner(chain, "loadCustomQuote");
export default loadCustomQuote;
